import { __rest, __assign } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Anchor, Label } from './styles.js';

var Link = function (_a) {
    var iconLeft = _a.iconLeft, iconRight = _a.iconRight, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.type, type = _c === void 0 ? 'standalone' : _c, children = _a.children, props = __rest(_a, ["iconLeft", "iconRight", "size", "type", "children"]);
    var standaloneLink = type === 'standalone';
    return (React.createElement(Anchor, __assign({}, props, { type: type }),
        standaloneLink && iconLeft,
        React.createElement(Label, { iconLeft: Boolean(standaloneLink && iconLeft), iconRight: Boolean(standaloneLink && iconRight), size: size, type: type }, children),
        standaloneLink && iconRight));
};

export { Link as default };
